import { render, staticRenderFns } from "./CronogramaProgressao.vue?vue&type=template&id=2684b3de&scoped=true"
import script from "./CronogramaProgressao.vue?vue&type=script&lang=js"
export * from "./CronogramaProgressao.vue?vue&type=script&lang=js"
import style0 from "./CronogramaProgressao.vue?vue&type=style&index=0&id=2684b3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684b3de",
  null
  
)

export default component.exports